<div *ngIf="!isWizard">
	<div nz-row *ngIf="hasAllDevices"><p> {{ 'workflow.needsWizard' | translate }} </p></div>
	<div nz-row *ngIf="!hasAllDevices"><p> {{ 'workflow.noDevices' | translate }} </p></div>
	<div nz-row nzJustify="start" [nzGutter]="[16, 6]">
		<div nz-col>
			<button nz-button [nzType]="hasAllDevices ? 'primary' : 'default'" (click)="showWizardLink()">
				{{ 'workflow.wizardOpen' | translate }}
			</button>
		</div>
		<div nz-col>
			<button *ngIf="!modalVisible && !hasGroupMissingValue" nz-button nzType="default" (click)="setOpenAlternateInput()">
				{{ 'workflow.openManualInputCompact' | translate }}
			</button>
			<button *ngIf="modalVisible && softLocked && !finishedAndLocked" nz-button nzType="default" (click)="removeSoftLock()">
				{{ 'workflow.editManualInputValuesCompact' | translate }}
			</button>
		</div>
	</div>
	<br/>

	<workflow-alternate-input-modal
			[finishedAndLocked]="finishedAndLocked"
			[question]="specialQuestion"
			[parentOverviewConfigs]="overviewConfigs"
			[isAlternateInputModalVisible]="modalVisible && !hasGroupMissingValue"
			[hasWorkflowWritePermission]="hasWorkflowWritePermission"
			[softLocked]="softLocked"
			[validationLevel]="validationLevel"
			(isAlternateInputModalNotVisible)="setCloseAlternateInput()">
	</workflow-alternate-input-modal>

	<div *ngIf="hasGroupMissingValue && (finishedAndLocked || overviewConfigs)" class="font-size-live div-table">
		<workflow-overview-item
				*ngFor="let config of overviewConfigs"
				[finishedAndLocked]="finishedAndLocked"
				[config]="config"
				[alignTextLeft]="true"
				class="div-table-line"
		></workflow-overview-item>
	</div>
</div>
<div *ngIf="isWizard">
	<!-- Container für Individuell Frage Komponenten -->
	<div nz-row class="alert-wizard-no-permission">
		<nz-alert
				*ngIf="!hasWorkflowWritePermission"
				class="big-warning-smaller-description text-center"
				nzType="warning" nzShowIcon
				nzMessage="{{ 'message.warning.noPermit' | translate }}"
				nzDescription="{{ 'message.warning.noPermit_description' | translate }}"
				nz-col nzSpan="24"
		>
		</nz-alert>
	</div>
	<ng-template #container [appWorkflowItemKey]="specialQuestion.key"></ng-template>
</div>
